export default (options={}) => ({
    open: false,

    close() {
        this.open = false;
        this.$removeScroll(true);

        if(_.get(options ?? {}, 'onClose')) {
            options.onClose();
        }
    },

    show(dispatch=null) {
        this.open = true;
        this.$removeScroll();

        if(dispatch) {
            this.$dispatch(dispatch);
        }
    },

    ...options,
})
